import {api} from '../api'
import {
    USER_LOGGED_IN, USER_LOGGED_OUT, JWT_ISSUED, SYSTEM_BOOT_RESOURCES_LOADED
} from './types';

export const attemptLogin = (auth) => (dispatch) => {
    return api.auth.attemptLogin(auth).then(res => {
        const {data} = res.data;
        const now = Math.floor(Date.now() / 1000);
        data.issued = now;
        saveState(data, 'dls-user');
        dispatch({
            type: USER_LOGGED_IN,
            payload: data
        });
        dispatch({
            type: JWT_ISSUED,
            payload: now
        });
        api.system.resources(data.jwt).then(res => {
            dispatch({
                type: SYSTEM_BOOT_RESOURCES_LOADED,
                payload: res.data.data
            });
            return res;
        }).catch(err => {
            throw err;
        })
    }).catch(err => {
        throw err;
    })
}

export const resetPassword = (email) => (dispatch) => {
    return api.auth.resetPassword(email);
}

export const postResetRequest = (reset) => (dispatch) => {
    return api.auth.postResetRequest(reset);
}

export const logOut = () => {
    deleteState('dls-user');
    return ({
        type: USER_LOGGED_OUT
    });
}

export const deleteState = (localName) => {
    try {
        localStorage.removeItem(localName);
        return true;
    } catch (err) {
        return false;
    }
}

export const saveState = (state, localName) => {
    try {
        const serializedState = JSON.stringify(state);
        localStorage.setItem(localName, serializedState);
        return true;
    } catch (err) {
        return false;
    }
}

export const loadState = (localName) => {
    try {
        const serializedState = localStorage.getItem(localName);
        if (serializedState === null) {
            return null;
        }
        return JSON.parse(serializedState);
    } catch (err) {
        return null;
    }
}


// WEBPACK FOOTER //
// ./src/actions/auth.js